import React from 'react';
import { Table } from '@mantine/core';
import { SectionCard } from '../../shared/SectionCard/SectionCard';
import { asCurrency } from '../../shared/utils/dashboard-page.utils';
import { SectionKey } from '../../shared/types/dashboard-page.types';
import { ReportView } from '../../../../services/reports/reports.service';
import classes from './sales-section.module.scss';

export type SalesSectionProps = {
  collapsedSections: Record<SectionKey, boolean>;
  toggleSection: (section: SectionKey) => void;
  report: ReportView | null;
  selectedRevenue: number;
};

export const SalesSection: React.FC<SalesSectionProps> = ({
  collapsedSections,
  toggleSection,
  report,
  selectedRevenue,
}) => {
  const grossTakeAway = report?.takeAwayRevenue ?? 0;
  const grossDineIn = report?.dineInRevenue ?? 0;
  const grossTotal = report?.closedRevenue ?? selectedRevenue;
  const vatFactor = 1 + Math.max(report?.vatRatePercent ?? 0, 0) / 100;

  const rows: Array<{ label: string; takeAway: string; dineIn: string; total: string }> = [
    {
      label: 'מכירות',
      takeAway: asCurrency(grossTakeAway / vatFactor),
      dineIn: asCurrency(grossDineIn / vatFactor),
      total: asCurrency(grossTotal / vatFactor),
    },
    {
      label: 'מכירות כולל מע"מ',
      takeAway: asCurrency(grossTakeAway),
      dineIn: asCurrency(grossDineIn),
      total: asCurrency(grossTotal),
    },
    {
      label: 'טיפ',
      takeAway: asCurrency(report?.takeAwayTips ?? 0),
      dineIn: asCurrency(report?.dineInTips ?? 0),
      total: asCurrency(report?.tipsTotal ?? 0),
    },
    {
      label: 'סועדים',
      takeAway: String(report?.takeAwayDinersCount ?? 0),
      dineIn: String(report?.dineInDinersCount ?? 0),
      total: String(report?.dinersCount ?? 0),
    },
    {
      label: 'ממוצע לסועד',
      takeAway: asCurrency(report?.avgPerDinerTakeAway ?? 0),
      dineIn: asCurrency(report?.dineInAvgPerDiner ?? 0),
      total: asCurrency(report?.avgPerDiner ?? 0),
    },
  ];

  return (
    <SectionCard title="מכירות" sectionKey="sales" collapsed={collapsedSections.sales} onToggle={() => toggleSection('sales')}>
      <Table className={classes.table}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th></Table.Th>
            <Table.Th>סה"כ</Table.Th>
            <Table.Th>ישיבה</Table.Th>
            <Table.Th>לקחת</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.label}>
              <Table.Th className={classes.labelCell}>{row.label}</Table.Th>
              <Table.Td>{row.total}</Table.Td>
              <Table.Td>{row.dineIn}</Table.Td>
              <Table.Td>{row.takeAway}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </SectionCard>
  );
};
